export default __webpack_public_path__ + "static/media/(24).46cee829.jpeg";